import { withModuleContext } from "@edreamsodigeo/frontend-core";
import { PrismaProvider } from "@edreamsodigeo/prisma-design-system";

const MODULE_NAMESPACE = "prime";
export default withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
